import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchData } from "../../../Components/common/utils";
const CompanyLogos = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [logosByCategory, setLogosByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const [categoryList, setCategoryList] = useState({});
  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/company/logo";
      const result = await fetchData(url);
      const bikeList = await fetchBikeData()
      if (result && result.data) {
        const list = result.data.reduce((acc, item) => {
          if(item.title==='E-Bikes'){
            item.title='E Bikes'
          }
          if (!acc[item.title]) {
            acc[item.title] = { slug: item.slug };
          }
          return acc;
        }, {});
        setCategoryList(list);
        result.data = result.data.filter(item => item.title !== 'E-Bikes')
        const categorizedLogos = {};
        result.data.forEach((item) => {
          const categoryTitle = item.title;
          if (!categorizedLogos[categoryTitle]) {
            categorizedLogos[categoryTitle] = [];
          }
          categorizedLogos[categoryTitle] = item.company_logos.map((logo) => ({
            id: logo.id,
            img: logo.media[0]?.original_url,
            slug: logo.slug,
            companyName: logo.title,
            companyslug: item.slug
          }));
        });
        categorizedLogos["E Bikes"] = bikeList?.map((bike) => ({
          id: bike.id,
          img: bike.media[0]?.original_url,
          slug: bike.slug,
          companyName: bike.title,
          companyslug: bike.slug
        }));
        const filteredData = Object.fromEntries(
          Object.entries(categorizedLogos).filter(([key, value]) => value.length > 0)
        );

        setCategories(Object.keys(filteredData));
        setLogosByCategory(filteredData);

        setSelectedCategory(Object.keys(filteredData)[0]);
      }
      setLoading(false);
    };

    fetchApiData();
  }, []);

  const fetchBikeData = async () => {
    const url = "api/bike/logo";
    const result = await fetchData(url);
    if (result && result.status === true) {
      // setLogoList(result.data);
      return result.data;
    }
    setLoading(false);
  };
  return (
    <>
      <section className="logo buy mt-1 mb-5 py-5">
        <div className="container">
          <h1 className="text-center mb-5">Company Logo</h1>
          {loading ? (
            <>
              <div className="d-flex align-items-center justify-content-center gap-2 my-5">
                <div className="skeleton tabs-btn"></div>
                <div className="skeleton tabs-btn"></div>
                <div className="skeleton tabs-btn"></div>
              </div>
              <div className=" text-center mt-4">
                {Array.from({ length: 6 }).map((_, i) => (
                  <img key={i} className="skeleton m-2" />
                ))}
              </div>
            </>
          ) : (
            <>
              <div className="d-flex align-items-center flex-wrap justify-content-center gap-2 my-5">
                {categories.map((category, index) => (
                  <button
                    key={index}
                    className={`tabs-btns ${selectedCategory === category ? "active" : ""
                      }`}
                    onClick={() => setSelectedCategory(category)}
                  >
                    {category}
                  </button>
                ))}
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap">
                {logosByCategory[selectedCategory]?.slice(0, 15).map((details, index) => (
                  <div
                    className="d-flex flex-column align-items-center justify-content-center gap-2"
                    key={index}
                  >
                    <Link
                      to={
                        selectedCategory.toLowerCase() === "electronics"
                          ? `electronics/${details.slug}`
                          : selectedCategory.toLowerCase() === "solar"
                            ? `solar/${details.slug}`
                            : selectedCategory.toLowerCase() === "e bikes" ? `e-bikes/${details.slug}` : `${details.companyslug}/${details.slug}`
                      }
                    >
                      <img
                        src={details.img}
                        alt={`${details.companyName} logo`}
                      />
                    </Link>
                    <p>{details.companyName}</p>
                  </div>
                ))}
              </div>
              {logosByCategory[selectedCategory]?.length > 15 && (
                <div className="text-center mt-4">
                  <Link to={`${categoryList[selectedCategory]?.slug}`} className="text-secondary text-decoration-none" >
                    <button className="btn btn-primary">View All</button>
                  </Link>
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default CompanyLogos;
